/**
 * Configuración y validación de variables de entorno para Team Spain.
 * Garantiza que el cliente no exponga secretos y valide la presencia de configuración.
 */

export interface AppEnvConfig {
  supabaseUrl: string
  supabaseAnonKey: string
  supabasePublishableKey: string
  appEnv: 'development' | 'production' | 'preview' | 'demo'
  isDemoMode: boolean
  isConfigured: boolean
}

const rawEnv = (import.meta.env.VITE_APP_ENV as AppEnvConfig['appEnv']) || 'development'
const isDemo = rawEnv === 'demo' || import.meta.env.VITE_DEMO_MODE === 'true'
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || ''
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''
const effectiveKey = publishableKey || anonKey

export const env: AppEnvConfig = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || '',
  supabaseAnonKey: anonKey,
  supabasePublishableKey: publishableKey,
  appEnv: rawEnv,
  isDemoMode: isDemo,
  isConfigured: Boolean(
    import.meta.env.VITE_SUPABASE_URL && effectiveKey
  ),
}

export function isSupabaseConfigured(): boolean {
  return env.isConfigured
}

export function isDemoEnvironment(): boolean {
  return env.isDemoMode
}
